import React from 'react';

export const LazyNoticePage = React.lazy(() => import('./NoticePage'));
